import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import moment from 'moment';
import FileInput from 'ui/components/file-input';
import Progress from '../ui/react-ui/progress.jsx';
import DropDown from '../ui/react-ui/dropdown';
import DatePicker from '../ui/react-ui/date-picker';
import ModalDialog from '../ui/modal-dialog';
import Form from '../ui/form';
import Input from '../ui/input';
import Textarea from '../ui/textarea';
import Validator from '../../utils/validator'; // Api

import { createTerminalBoardAPI, editTerminalBoardAPI } from '../../api/settingAPI';

var _t = i18n.getFixedT(null, 'setting-terminalBoard');

var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var TerminalBoardEdit = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      terminalsList = _useSelector.app.terminalsList;

  var id = props.id,
      onClose = props.onClose,
      _props$dialogData = props.dialogData,
      mode = _props$dialogData.mode,
      data = _props$dialogData.data;
  var initImagesData = Array.from({
    length: 3
  }, function (_, index) {
    return {
      imageFile: null,
      imageBase64: '',
      imagePath: '',
      show: false,
      keyNumber: index + 1
    };
  });
  var initFileData = {
    path: '',
    file: null
  };

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      formData = _useState2[0],
      setFormData = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      linksData = _useState6[0],
      setLinksData = _useState6[1];

  var _useState7 = useState(initFileData),
      _useState8 = _slicedToArray(_useState7, 2),
      fileData = _useState8[0],
      setFileData = _useState8[1];

  var _useState9 = useState(initImagesData),
      _useState10 = _slicedToArray(_useState9, 2),
      imagesData = _useState10[0],
      setImagesData = _useState10[1];

  var form_ref = useRef(null);
  var initTime = {
    beginTime: moment().format('YYYY-MM-DD HH:mm'),
    endTime: moment().add(1, 'days').format('YYYY-MM-DD HH:mm')
  };

  var resetState = function resetState() {
    setFormData({});
    setLinksData([]);
    setFileData(initFileData);
    setImagesData(initImagesData);
    setError();
  };

  var handleClose = function handleClose() {
    resetState();
    onClose();
  };

  var handleChange = function handleChange(value, path) {
    var newData = _.cloneDeep(formData);

    if (path === 'beginTime' || path === 'endTime') _.set(newData, path, value.length === 16 ? value + ':00' : value);else _.set(newData, path, value);
    setFormData(newData);
    setError();
  }; // links function


  var hanldeNewLinks = function hanldeNewLinks() {
    var newLinksData = _.clone(linksData);

    var newIndex = newLinksData.length === 0 ? 0 : newLinksData[newLinksData.length - 1].index + 1;
    newLinksData.push({
      index: newIndex,
      linkName: '',
      linkUrl: ''
    });
    setLinksData(newLinksData);
  };

  var handleLinkChange = function handleLinkChange(val, path, index) {
    var newLinksData = _.clone(linksData);

    var curItem = _.find(newLinksData, function (el) {
      return parseInt(el.index) === index;
    });

    _.set(curItem, path, val);

    setLinksData(newLinksData);
  };

  var handleRemoveLinks = function handleRemoveLinks(index) {
    var newLinksData = _.filter(_.clone(linksData), function (el) {
      return parseInt(el.index) !== index;
    });

    setLinksData(newLinksData);
  }; // file function


  var handleFileChange = function handleFileChange(file) {
    setFileData(_objectSpread(_objectSpread({}, fileData), {}, {
      file: file
    }));
  };

  var handleRemoveFile = function handleRemoveFile() {
    setFileData(initFileData);
  }; // images function


  var hanldeNewImage = function hanldeNewImage() {
    var newImagesData = _.clone(imagesData);

    for (var i = 0; i < newImagesData.length; i++) {
      if (newImagesData[i].show !== true) {
        newImagesData[i].show = true;
        break;
      }
    }

    setImagesData(newImagesData);
  };

  var handleRemoveImages = function handleRemoveImages(keyNumber) {
    var otherItems = imagesData.filter(function (el) {
      return el.keyNumber !== keyNumber;
    });
    var removeItem = imagesData.filter(function (el) {
      return el.keyNumber === keyNumber;
    })[0];
    removeItem.show = false;
    removeItem.imageFile = null;
    removeItem.imageBase64 = '';
    removeItem.imagePath = '';
    var newImagesData = [].concat(_toConsumableArray(otherItems), [removeItem]);
    setImagesData(newImagesData);
  };

  var handleImageChange = function handleImageChange(file, keyNumber) {
    var newImagesData = _.clone(imagesData);

    var curItem = _.find(newImagesData, function (el) {
      return parseInt(el.keyNumber) === keyNumber;
    });

    var reader = new FileReader();

    reader.onloadend = function () {
      _.set(curItem, 'imageFile', file);

      _.set(curItem, 'imageBase64', reader.result);

      _.set(curItem, 'imagePath', '');

      setImagesData(newImagesData);
    };

    reader.readAsDataURL(file);
  };

  var handleConfirm = function handleConfirm() {
    var fillOutRequired = Validator(['title', 'description'], formData);
    if (fillOutRequired.length > 0) return setError(et('txt-fill-out-required'));
    if (_.isEmpty(formData.beginTime)) return setError(_t('txt-beginTime-required'));
    if (_.isEmpty(formData.terminalId)) return setError(_t('txt-terminal-required'));

    var commitData = _.clone(formData);

    var commitFormData = new FormData(); // link

    for (var i = 1; i <= 3; i++) {
      var nameKey = "linkName".concat(i);
      var urlKey = "linkUrl".concat(i);

      if (linksData[i - 1] && (linksData[i - 1].linkUrl || linksData[i - 1].linkName)) {
        _.set(commitData, nameKey, linksData[i - 1].linkName ? linksData[i - 1].linkName : _t("dlg-link".concat(i)));

        _.set(commitData, urlKey, linksData[i - 1].linkUrl);
      } else {
        _.set(commitData, nameKey, '');

        _.set(commitData, urlKey, '');
      }
    } // file


    if (fileData && fileData.file) {
      _.set(commitData, 'pdfPath1', '');

      commitFormData.append('pdfFile1', fileData.file);
    } else if (fileData && _.isEmpty(fileData.path) && _.isEmpty(fileData.file)) {
      _.set(commitData, 'pdfPath1', '');
    } // image


    for (var _i = 0; _i < imagesData.length; _i++) {
      var item = imagesData[_i];

      if (item.show) {
        if (item.imageFile) {
          commitFormData.append("imageFile".concat(item.keyNumber), item.imageFile);

          _.set(commitData, "imagePath".concat(item.keyNumber), '');
        }
      } else {
        _.set(commitData, "imagePath".concat(item.keyNumber), '');
      }
    }

    Progress.startSpin();
    var confirmApi = mode === 'edit' ? editTerminalBoardAPI : createTerminalBoardAPI;
    confirmApi(contextRoot, true, commitData, commitFormData).then(function (result) {
      resetState();
      onClose('confirm');
    }).catch(function (error) {
      Progress.done();
      setError(et(error.messageCode) === _.toString(error.messageCode) ? error.message : et(error.messageCode));
    });
  };

  useEffect(function () {
    if (mode === 'edit') {
      (function () {
        setFormData(data); // handle links edit

        var newLinksData = [];

        for (var i = 1; i <= 3; i++) {
          var linkUrlKey = "linkUrl".concat(i);
          var linkNameKey = "linkName".concat(i);

          if (data[linkUrlKey] || data[linkNameKey]) {
            newLinksData.push({
              index: i - 1,
              linkName: data[linkNameKey],
              linkUrl: data[linkUrlKey]
            });
          }
        }

        setLinksData(newLinksData); // handle file edit

        if (data.pdfPath1) setFileData({
          path: data.pdfPath1,
          file: null
        }); // handle image edit

        var imageKeyMappings = {
          imagePath1: 1,
          imagePath2: 2,
          imagePath3: 3
        };

        var newImagesData = _.clone(initImagesData);

        var _loop = function _loop(key) {
          if (imageKeyMappings.hasOwnProperty(key) && data[key]) {
            var targetElement = newImagesData.find(function (el) {
              return el.keyNumber === imageKeyMappings[key];
            });

            if (targetElement) {
              targetElement.imagePath = data[key];
              targetElement.show = true;
            }
          }
        };

        for (var key in imageKeyMappings) {
          _loop(key);
        }

        setImagesData(newImagesData);
      })();
    } else {
      setFormData({
        beginTime: initTime.beginTime + ':00'
      });
    }
  }, [mode]);
  if (_.isEmpty(mode) || mode === 'edit' && _.isEmpty(formData.id)) return null;
  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-answer-cancel'),
    handler: handleClose
  });

  _.set(actions, 'confirm', {
    text: gt('global.lbl-answer-ok'),
    className: 'button-success',
    // disabled: !formValid,
    handler: handleConfirm
  });

  var fields = {};

  _.set(fields, 'terminalId', {
    label: _t('lbl-terminal'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(DropDown, {
        list: terminalsList,
        width: '350px',
        defaultText: gt('global.lbl-select'),
        value: val ? val : '',
        required: true,
        onChange: function onChange(value) {
          return handleChange(value, 'terminalId');
        }
      });
    }
  });

  _.set(fields, 'title', {
    label: _t('lbl-title'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(Input, {
        value: val ? val : '',
        validate: {
          required: true,
          t: function t(code) {
            return et("txt-".concat(code));
          }
        },
        onChange: function onChange(val) {
          return handleChange(val, 'title');
        }
      });
    }
  });

  _.set(fields, 'description', {
    label: _t('lbl-description'),
    editor: null,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Textarea, {
        onChange: function onChange(val) {
          return handleChange(val, 'description');
        },
        value: val,
        validate: {
          required: true,
          t: function t(code) {
            return et("txt-".concat(code));
          }
        }
      }));
    }
  });

  _.set(fields, 'beginTime', {
    label: _t('lbl-beginTime'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(DatePicker, {
        id: "datetime",
        onChange: function onChange(val) {
          return handleChange(val, 'beginTime');
        },
        enableTime: true,
        value: val
      });
    }
  });

  _.set(fields, 'endTime', {
    label: _t('lbl-endTime'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(DatePicker, {
        id: "datetime",
        onChange: function onChange(val) {
          return handleChange(val, 'endTime');
        },
        enableTime: true,
        value: val
      });
    }
  });

  _.set(fields, 'links', {
    label: _t('dlg-link'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "attached-block"
      }, _.map(linksData, function (el, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "attached-inputs",
          key: "link-".concat(el.index)
        }, /*#__PURE__*/React.createElement("div", {
          className: "attached-header"
        }, /*#__PURE__*/React.createElement("div", {
          className: "title"
        }, _t("dlg-link".concat(index + 1))), /*#__PURE__*/React.createElement("i", {
          className: "fas fa-times",
          onClick: function onClick() {
            return handleRemoveLinks(el.index);
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "attached-body"
        }, /*#__PURE__*/React.createElement("div", {
          className: "attached-input-item"
        }, /*#__PURE__*/React.createElement("label", null, _t("dlg-link-name")), /*#__PURE__*/React.createElement(Input, {
          value: el.linkName ? el.linkName : '',
          validate: {
            // required: true,
            t: function t(code) {
              return et("txt-".concat(code));
            }
          },
          onChange: function onChange(val) {
            return handleLinkChange(val, "linkName", el.index);
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "attached-input-item"
        }, /*#__PURE__*/React.createElement("label", null, _t("dlg-link-url")), /*#__PURE__*/React.createElement(Input, {
          value: el.linkUrl ? el.linkUrl : '',
          validate: {
            // required: true,
            t: function t(code) {
              return et("txt-".concat(code));
            }
          },
          onChange: function onChange(val) {
            return handleLinkChange(val, "linkUrl", el.index);
          }
        }))));
      }), linksData.length < 3 && /*#__PURE__*/React.createElement("div", {
        className: "new-icon",
        onClick: function onClick() {
          return hanldeNewLinks();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-plus"
      })));
    }
  });

  _.set(fields, 'file', {
    label: _t('dlg-file'),
    formatter: function formatter(val, row) {
      var fileName = '';
      if (fileData && fileData.path) fileName = fileData.path.split('/').pop();
      var showPreviewFile = fileData && (fileData.path || fileData.file);
      return /*#__PURE__*/React.createElement("div", {
        className: "c-flex aic file-input"
      }, /*#__PURE__*/React.createElement(FileInput, {
        disabled: false,
        btnText: _t('dlg-select-file'),
        onChange: handleFileChange,
        required: true,
        name: "fileDemo",
        validate: {
          // max: 10,
          extension: ['.pdf'],
          t: function t(code, params) {
            return _t('error-file-format-should-be', {
              format: params.extension
            });
          }
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "download-file"
      }, showPreviewFile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
        href: fileData.path ? "".concat(contextRoot, "/fileServer").concat(fileData.path) : URL.createObjectURL(fileData.file)
      }, fileData.path ? fileName : fileData.file.name), /*#__PURE__*/React.createElement("i", {
        className: "fas fa-times",
        onClick: function onClick() {
          return handleRemoveFile();
        }
      }))));
    }
  });

  _.set(fields, 'images', {
    label: _t('dlg-image'),
    formatter: function formatter(val, row) {
      var showItems = imagesData.filter(function (item) {
        return item.show;
      });
      var showCount = showItems.length;
      return /*#__PURE__*/React.createElement("div", {
        className: "attached-block"
      }, _.map(showItems, function (el, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "attached-inputs",
          key: "images-".concat(el.keyNumber)
        }, /*#__PURE__*/React.createElement("div", {
          className: "attached-header"
        }, /*#__PURE__*/React.createElement("div", {
          className: "title"
        }, _t("dlg-image".concat(index + 1))), /*#__PURE__*/React.createElement("i", {
          className: "fas fa-times",
          onClick: function onClick() {
            return handleRemoveImages(el.keyNumber);
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "attached-body"
        }, /*#__PURE__*/React.createElement(FileInput, {
          disabled: false,
          btnText: _t('dlg-select-file'),
          onChange: function onChange(file) {
            return handleImageChange(file, el.keyNumber);
          },
          required: true,
          name: "fileDemo",
          validate: {
            // max: 10,
            extension: ['.jpg', '.png', '.JPG', '.PNG'],
            t: function t(code, params) {
              return _t('error-file-format-should-be', {
                format: params.extension
              });
            }
          }
        }), /*#__PURE__*/React.createElement("div", {
          className: "image-preview"
        }, el.imagePath && /*#__PURE__*/React.createElement("img", {
          src: "".concat(contextRoot, "/fileServer").concat(el.imagePath),
          alt: "Preview"
        }), el.imageBase64 && /*#__PURE__*/React.createElement("img", {
          src: el.imageBase64,
          alt: "Preview"
        }))));
      }), showCount < 3 && /*#__PURE__*/React.createElement("div", {
        className: "new-icon",
        onClick: function onClick() {
          return hanldeNewImage();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-plus"
      })));
    }
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: _t("dlg-terminalBoard-".concat(mode)),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form"),
    ref: form_ref,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    onChange: handleChange,
    value: formData
  }));
});
TerminalBoardEdit.defaultProps = {
  id: 'g-terminalBoard-edit'
};
TerminalBoardEdit.propTypes = {
  id: PropTypes.string
};
export default TerminalBoardEdit;